const formatAmountWithDollar = (
  amount: number | string | undefined,
  lang = 'en',
  showZero = false
): string => {
  if (!showZero && (!amount || parseFloat(amount as string) === 0)) return '';

  const locale = `${lang || 'en'}-CA`;

  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'CAD'
  }).format(Number(amount));

  return formatted;
};

export default formatAmountWithDollar;
